import React from "react";
import {
  Grid,
  Container,
  Card,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { TyCStyles } from "./TyCStyles";
import { useTranslation } from "react-i18next";

export function CookiesPolicityTyC(props) {
  const classes = TyCStyles();
  const { t, i18n } = useTranslation();

  return (
    <Grid
      className={
        !props.showSideMenu ? classes.container : classes.hideContainer
      }
    >
      <Container maxWidth={"lg"} className={classes.mainContainer}>
        <Card className={classes.cardContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="justify" className={classes.text}>
                <p>{t("cookiesPolicyText00_01")}</p>

                <ol>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle01")}
                    </h5>
                  </li>
                  <p>{t("cookiesPolicyText01_01")}</p>
                  <p>{t("cookiesPolicyText01_02")}</p>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle02")}
                    </h5>
                    <p>
                      {t("cookiesPolicyText02_01")}
                    </p>
                    <ol>
                      <li>
                        <h5 className={classes.subtitles}>
                          {t("cookiesPolicyTitle02_01")}
                        </h5>
                        <ul>
                          <li><p><b>{t("cookiesPolicyText0201_01")}</b>{t("cookiesPolicyText0201_02")}</p></li>
                          <li><p><b>{t("cookiesPolicyText0201_03")}</b>{t("cookiesPolicyText0201_04")}</p></li>
                        </ul>
                      </li>
                      <li>
                        <h5 className={classes.subtitles}>
                          {t("cookiesPolicyTitle02_02")}
                        </h5>
                        <ul>
                          <li><p><b>{t("cookiesPolicyText0202_01")}</b>{t("cookiesPolicyText0202_02")}</p></li>
                          <li><p><b>{t("cookiesPolicyText0202_03")}</b>{t("cookiesPolicyText0202_04")}</p></li>
                        </ul>
                      </li>
                      <li>
                        <h5 className={classes.subtitles}>
                          {t("cookiesPolicyTitle02_03")}
                        </h5>
                        <ul>
                          <li><p><b>{t("cookiesPolicyText0203_01")}</b>{t("cookiesPolicyText0203_02")}</p></li>
                          <li><p><b>{t("cookiesPolicyText0203_03")}</b>{t("cookiesPolicyText0203_04")}</p></li>
                          <li><p><b>{t("cookiesPolicyText0203_05")}</b>{t("cookiesPolicyText0203_06")}</p></li>
                          <li><p><b>{t("cookiesPolicyText0203_07")}</b>{t("cookiesPolicyText0203_08")}</p></li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle03")}
                    </h5>
                    <p>{t("cookiesPolicyText03_01")}</p>
                    <p><b>{t("cookiesPolicyText03_02")}</b></p>
                    <Table className={classes.table}>
                      <TableBody>
                        <TableRow className={classes.tableHead}>
                          <TableCell className={classes.tableHeadText}>
                            {t("cookiesPolicyText03t_01")}
                          </TableCell>
                          <TableCell className={classes.tableHeadText}>
                            {t("cookiesPolicyText03t_02")}
                          </TableCell>
                          <TableCell className={classes.tableHeadText}>
                            {t("cookiesPolicyText03t_03")}
                          </TableCell>
                          <TableCell className={classes.tableHeadText}>
                            {t("cookiesPolicyText03t_04")}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>{t("cookiesPolicyText03t_05")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_06")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_07")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_08")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>{t("cookiesPolicyText03t_09")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_10")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_11")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_12")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>{t("cookiesPolicyText03t_13")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_14")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_15")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_16")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>{t("cookiesPolicyText03t_17")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_18")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_19")}</TableCell>
                          <TableCell>{t("cookiesPolicyText03t_20")}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle04")}
                    </h5>
                    <ol>
                      <li>
                        <h5 className={classes.subtitles}>
                          {t("cookiesPolicyTitle04_01")}
                        </h5>
                        <p>
                          {t("cookiesPolicyText0401_01")}
                        </p>
                      </li>
                      <li>
                        <h5 className={classes.subtitles}>
                          {t("cookiesPolicyTitle04_02")}
                        </h5>
                        <p>{t("cookiesPolicyText0402_01")}</p>
                        <ul>
                          <li><p>{t("cookiesPolicyText0402_02")}</p></li>
                          <li><p>{t("cookiesPolicyText0402_03")}</p></li>
                          <li><p>{t("cookiesPolicyText0402_04")}</p></li>
                          <li><p>{t("cookiesPolicyText0402_05")}</p></li>
                        </ul>
                        <p>{t("cookiesPolicyText0402_06")}</p>
                        <ul>
                          <li><p>{t("cookiesPolicyText0402_07")}<b><a href="https://support.google.com/chrome/answer/95647?hl=es" className={classes.links} target="_blank" rel="noopener noreferrer">https://support.google.com/chrome/answer/95647?hl=es</a></b></p></li>
                          <li><p>{t("cookiesPolicyText0402_08")}<b><a href="https://support.mozilla.org/es/kb/Borrar%20Cookies" className={classes.links} target="_blank" rel="noopener noreferrer">https://support.mozilla.org/es/kb/Borrar%20Cookies</a></b></p></li>
                          <li><p>{t("cookiesPolicyText0402_09")}<b><a href="https://support.microsoft.com/es-es/help/4027947/microsoft-edge-delete-Cookies" className={classes.links} target="_blank" rel="noopener noreferrer">https://support.microsoft.com/es-es/help/4027947/microsoft-edge-delete-Cookies</a></b></p></li>
                          <li><p>{t("cookiesPolicyText0402_10")}<b><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" className={classes.links} target="_blank" rel="noopener noreferrer">https://support.apple.com/es-es/guide/safari/sfri11471/mac</a></b></p></li>
                        </ul>
                        <p>{t("cookiesPolicyText0402_11")}</p>
                        <ul>
                          <li><p><b>{t("cookiesPolicyText0402_12")}</b><b><a href="www.ghostery.com/" className={classes.links} target="_blank" rel="noopener noreferrer">www.ghostery.com/</a></b></p></li>
                          <li><p><b>{t("cookiesPolicyText0402_13")}</b><b><a href="www.youronlinechoices.com/es/" className={classes.links} target="_blank" rel="noopener noreferrer">www.youronlinechoices.com/es/</a></b></p></li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle05")}
                    </h5>
                    <p>
                      {t("cookiesPolicyText05_01")}
                    </p>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("cookiesPolicyTitle06")}
                    </h5>
                    <p>
                      {t("cookiesPolicyText06_01")}
                    </p>
                    <p>
                      {t("cookiesPolicyText06_02")}
                    </p>
                    <p>
                      {t("cookiesPolicyText06_03")}
                    </p>
                    <p>
                      {t("cookiesPolicyText06_04a")}
                      <b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDePrivacidad" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText06_04b")}</a></b>
                      {t("cookiesPolicyText06_04c")}
                    </p>
                  </li>
                </ol>
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Grid>
  );
}
